import { LinkButton } from '@cian/ui-kit';

import { stopPropagation } from '../../utils/event';
import { useOffer, usePublisher } from '../../hooks';

export function AgentBookButtonContainer() {
  const {
    bookButton: { link, title },
  } = usePublisher();
  const { isCianPartner } = useOffer();

  if (!isCianPartner) {
    return null;
  }

  return (
    <LinkButton
      onClick={stopPropagation}
      href={link}
      fullWidth
      size="XS"
      theme="fill_primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      {title}
    </LinkButton>
  );
}
